import { render, staticRenderFns } from "./custom-tooltip.vue?vue&type=template&id=3b5152f8&"
import script from "./custom-tooltip.vue?vue&type=script&lang=js&"
export * from "./custom-tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports